import axios from 'axios';
import interceptors from '../interceptors';

interceptors();

const baseUrl = '/designspec/api';

export function getCoverImages() {
  return axios.get(`${baseUrl}/cover-images`).then(res =>
    Object.values(res.data).map(({image, name, id}) => ({
      src: image,
      alt: name,
      value: id
    }))
  );
}

export function syncProject(data) {
  return axios.post(`${baseUrl}/local/projects`, data).then(res => res.data);
}

export function shareProject(id, data) {
  return axios.post(`${baseUrl}/projects/${id}/share`, data).then(res => res.data);
}

export function getProject(id) {
  return axios.get(`${baseUrl}/projects/${id}`).then(res => {
    return res.data;
  });
}

export function getSharedProject(id, shareToken) {
  return axios.get(`${baseUrl}/projects/${id}/shared/${shareToken}`).then(res => {
    return res.data;
  });
}

export const designspec = {
  async createProject(data) {
    const res = await axios.post(`${baseUrl}/projects`, data);
    const {
      data: {project_name: name, cover_image: coverImage, ...rest}
    } = res;
    return {...rest, name, coverImage};
  },
  async updateProject(data) {
    const {id, ...rest} = data;
    const res = await axios.put(`${baseUrl}/projects/${id}`, rest);
    return res.data;
  },
  async deleteProject({id}) {
    const res = await axios.delete(`${baseUrl}/projects/${id}`);
    return res.data;
  },
  async getProjects() {
    const res = await axios.get(`${baseUrl}/projects`);
    return res.data;
  },
  async validateProduct(projectId, product) {
    try {
      const res = await axios.post(
        `${baseUrl}/projects/${projectId}/validate`,
        product
      );
      if (res.status === 200) {
        return [];
      }
    } catch (e) {
      if (e.isAxiosError) {
        return e.response.data.messages;
      }
      throw e;
    }
    return [];
  }
};

